export const countProductComments = (ratingsArray) => {
  return ratingsArray?.filter((rating) => rating.comment !== null).length;
};
